// Admin Failed Jobs service
// Uses httpClient (no JWT required) per API spec

import { httpClient, unwrapApiResult } from './httpClient';
import { apiPath } from '../config/env';
import type { AdminJobFilters, AdminJobListResponse } from '../types/adminJobs';

/**
 * Fetch paginated list of failed/cancelled diagnosis jobs across all users.
 */
export async function getAdminFailedJobs(filters: AdminJobFilters = {}): Promise<AdminJobListResponse> {
    const params = new URLSearchParams();

    if (filters.user_email) params.set('user_email', filters.user_email);
    if (filters.source_type) params.set('source_type', filters.source_type);
    if (filters.from_date) params.set('from_date', filters.from_date);
    if (filters.to_date) params.set('to_date', filters.to_date);
    if (filters.status_filter) params.set('status_filter', filters.status_filter);
    params.set('limit', String(filters.limit ?? 20));
    params.set('offset', String(filters.offset ?? 0));
    params.set('order_by', filters.order_by ?? 'created_at');
    params.set('order_direction', filters.order_direction ?? 'desc');

    const result = await httpClient.get<AdminJobListResponse>(
        apiPath(`data-analysis/data-diagnosis/admin/failed-jobs?${params.toString()}`)
    );

    return unwrapApiResult(result);
}

export const adminJobsService = { getAdminFailedJobs };
